<template>
    <div class="box">
        <div class="headbox" :class="index != dataList.length - 1 ? 'btmold' : ''" v-for="(item, index) of dataList"
            :key="index">
            <div class="dis_f">
                <img :src="item.icon" width="18" height="20" alt="">
                <span>{{ item.title }}</span>
            </div>
            <div :class="v.info == dataIndex ? 'curr' : 'lable'" v-for="(v, j) of item.const"
                @click="checkAdd(index, j, v.info)" :key="j">
                <div class="find" v-if="v.info == dataIndex"></div>
                {{ v.name }}
            </div>
        </div>
    </div>
</template>

<script>
import { createLogger } from 'vuex';

export default {
    name: '',
    data() {
        return {
            dataIndex: 0,
            dataList: [
                {
                    title: '关于我们',
                    icon: require('../../image/gywm.png'),
                    const: [
                        {
                            name: '企业简介',
                            path: 'CorporateCulture',
                            info: 0
                        },
                        {
                            name: '发展历程',
                            path: 'CorporateCulture',
                            info: 1
                        },
                        {
                            name: '企业荣誉',
                            path: 'CorporateCulture',
                            info: 2
                        },
                        {
                            name: '核心优势',
                            path: 'CorporateCulture',
                            info: 3
                        },
                        {
                            name: '广告投放',
                            path: 'CorporateCulture',
                            info: 4
                        }
                    ]
                },
                {
                    title: '企业文化',
                    icon: require('../../image/qywh.png'),
                    const: [
                        {
                            name: '文化理念',
                            path: 'CorporateCulture',
                            info: 5
                        },
                        {
                            name: '文化场景',
                            path: 'CorporateCulture',
                            info: 6
                        },
                        {
                            name: '服务准则',
                            path: 'CorporateCulture',
                            info: 7
                        }
                    ]
                },
                {
                    title: '团队风采',
                    icon: require('../../image/tdfc.png'),
                    const: [
                        {
                            name: '核心团队展示',
                            path: 'CorporateCulture',
                            info: 8
                        },
                        {
                            name: '团队风采展示',
                            path: 'CorporateCulture',
                            info: 9
                        },
                        {
                            name: '团队视频',
                            path: 'CorporateCulture',
                            info: 10
                        },
                        {
                            name: '团队标签',
                            path: 'CorporateCulture',
                            info: 11
                        },
                        {
                            name: '联系方式',
                            path: 'CorporateCulture',
                            info: 12
                        },
                        {
                            name: '用户服务协议',
                            path: 'CorporateCulture',
                            info: 13
                        }
                    ]
                }
            ]
        };
    },
    created() {

    },
    mounted() {
        const type = this.$route.query.type
  if (type !== undefined) {
    this.dataIndex = Number(type)
  }
    },
    computed: {
        // 根据当前路由计算出高亮项的 info
        currentInfo() {
            const currentRoute = this.$route;
            for (let i = 0; i < this.dataList.length; i++) {
                const group = this.dataList[i];
                for (let j = 0; j < group.const.length; j++) {
                    const item = group.const[j];
                    if (item.path === currentRoute.name) {
                        // 如果路由需要 params 参数，则进一步校验 query.type
                        if (item.params !== undefined && item.params !== null) {
                            if (Number(currentRoute.query.type) === item.params) {
                                return item.info;
                            }
                        } else {
                            return item.info;
                        }
                    }
                }
            }
            return 0; // 默认高亮
        }
    },
    methods: {
        checkAdd(index, j, info) {
            console.log(index, j, info, '000')

            // this.$nextTick(() => {
            this.dataIndex = info
            // });
            if (this.dataList[index].const[j].info >= 0) {
                this.$router.push({ name: this.dataList[index].const[j].path, query: { type: this.dataList[index].const[j].info } })
            } else {
                this.$router.push({ name: this.dataList[index].const[j].path })
            }

        }
    },
}
</script>
<style scoped lang='less'>
.box {
    width: 192px;
    min-height: 712px;
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    // margin: 25px 0;

    .btmold {
        border-bottom: 1px solid #DFDFDF;
    }

    .headbox {
        cursor: pointer;

        .dis_f {
            display: flex;
            align-items: center;
            width: 120px;
            margin: 25px auto 0;
            padding-bottom: 10px;

            img {}

            span {
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                margin-left: 20px;

            }
        }

        .lable {
            // width: 100px;
            height: 50px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            text-align: center;
            margin: 5px auto;
            line-height: 50px;
        }

        .curr {
            width: 192px;
            height: 50px;
            background: #E8F2FE;
            border-radius: 0px 0px 0px 0px;
            font-weight: 500;
            font-size: 14px;
            color: #0074FF;
            text-align: center;
            line-height: 50px;
            margin: 5px 0;
            position: relative;

            .find {
                width: 4px;
                height: 20px;
                border-radius: 16px;
                background-color: #0074FF;
                position: absolute;
                left: 0;
                top: 0;
                transform: translate(-50%, 50%);
            }
        }
    }
}
</style>